import { render, staticRenderFns } from "./MailConnectionSettings.vue?vue&type=template&id=c89cdcba&scoped=true&"
import script from "./MailConnectionSettings.vue?vue&type=script&lang=babel&"
export * from "./MailConnectionSettings.vue?vue&type=script&lang=babel&"
import style0 from "./MailConnectionSettings.vue?vue&type=style&index=0&id=c89cdcba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89cdcba",
  null
  
)

export default component.exports